import { Content } from 'components/Modal';
import { Footer, MediaWrap, StyledHeaderSkeleton, StyledSkeleton } from './PerkzWalletModal.styles';

const PerkzWalletModalSkeleton = () => (
  <>
    <MediaWrap>
      <StyledHeaderSkeleton variant="rectangular" animation="wave" width="100%" />
    </MediaWrap>
    <Content>
      <StyledSkeleton variant="rectangular" animation="wave" height={50} width="100%" />
      <StyledSkeleton variant="text" animation="wave" width="100%" />
      <StyledSkeleton variant="rectangular" animation="wave" height={150} width="100%" />
      <StyledSkeleton variant="rectangular" animation="wave" height={40} width="100%" />
      <Footer>
        <StyledSkeleton variant="rectangular" animation="wave" height={30} width="100%" />
        <StyledSkeleton variant="rectangular" animation="wave" height={40} width="100%" />
        <StyledSkeleton variant="rectangular" animation="wave" height={30} width={200} />
      </Footer>
    </Content>
  </>
);

export default PerkzWalletModalSkeleton;
